import React from 'react';
import classes from './PressKit.css';

import Aux from '../../hoc/Aux';
import DownloadIcon from '../../assets/icons/download.svg';
import ViewIcon from '../../assets/icons/view.svg';

const pressKit = props => {
    return (
        <Aux>
            <img src={props.image} alt={props.name} className="img-fluid" />
            <div className={classes.Info}>
                <div className={classes.Title}>{props.title}</div>
                <div className={classes.Description}>{props.description}</div>
                {props.collectionLink && props.campaignLink ? (
                    <div className={classes.Submenu}>
                        <a href={props.collectionLink}>Colección</a>
                        <span className={classes.Separator}>|</span>
                        <a href={props.campaignLink}>Campaña</a>
                    </div>
                ) : null}
                <div className={classes.Actions}>
                    <span>Press Kit</span>
                    <a href={props.downloadLink}>
                        <img src={DownloadIcon} alt="Descargar" />
                    </a>
                    <a href="">
                        <img src={ViewIcon} alt="Ver" />
                    </a>
                </div>
            </div>
        </Aux>
    );
};

export default pressKit;



// WEBPACK FOOTER //
// ./src/components/PressKit/PressKit.js